const stripHtmlTagFromIndex = (value, startIndex) => {
  const endIndex = value.indexOf('>', startIndex);
  if (endIndex === -1) {
    return value.slice(0, startIndex);
  }
  return value.slice(0, startIndex) + value.slice(endIndex + 1);
};

/** Strips HTML tags and normalizes common entities from Honest Jobs rich-text fields. */
export const stripHtmlTags = (html) => {
  let stripped = String(html ?? '');
  let tagStart = stripped.indexOf('<');

  while (tagStart !== -1) {
    stripped = stripHtmlTagFromIndex(stripped, tagStart);
    tagStart = stripped.indexOf('<');
  }

  return stripped
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .trim();
};

/** Formats a reentry-plan address object into a single display line. */
export const formatReentryPlanAddress = (address = {}) => {
  const line1 = [address.addressLine1, address.addressLine2].filter(Boolean).join(', ');
  const cityStateZip = [address.city, address.county, address.state, address.postalCode]
    .filter(Boolean)
    .join(', ');
  return [line1, cityStateZip].filter(Boolean).join(', ');
};
